import React, { useEffect, useState } from 'react'
import { ReactComponent as Logo } from '../../assets/Logo-white.svg'
import './Footer.scss'

interface FooterProps {
    
}

const Footer:React.FC<FooterProps> = ({}) => {
    const [date, setDate] = useState<number>()

    useEffect(()=>{
        let currDate = new Date
        setDate(currDate.getFullYear())
    })
    return (
        <div className='Footer'>
            <div className="footer-top">
                <div className="container d-flex justify-content-between flex-wrap">
                    <div className="logo-socials-container сol-12 col-md-6">
                        <Logo className='logo' />
                        <div className="socials-container">
                            <div className="social me-3">
                                <i className='fab fa-facebook-f'/>
                            </div>
                            <div className="social mx-3">
                                <i className='fab fa-instagram'/>
                            </div>
                            <div className="social ms-3">
                                <i className='fab fa-linkedin-in'/>
                            </div>
                        </div>
                    </div>
                    <div className="links-subscription-container col-12 col-md-6">
                        <div className="links-block col-12 col-md-5">
                            <a href="" className="link ps-0">Services</a>
                            <a href="" className="link">Contact us</a>
                            <a href="" className="link ps-0">Portfolio</a>
                            <a href="" className="link">Terms</a>
                            <a href="" className="link ps-0">About us</a>
                            <a href="" className="link">Privacy</a>
                        </div>
                        <div className="newsletter-block col-12 col-md-7">
                            <label className='input-label' htmlFor="email">Send to us your email for auto feedback</label>
                            <div className="input-container">
                                <input type="text" name='email' className="input w-75" />
                                <div className="btn w-25">Send</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                All right reserved | © Rubicon LTD  2020 - {date}
            </div>
        </div>
    )
}

export default Footer